import { useCallback, useEffect, useState } from 'react';

const PREFIX = 'qcs-hint-';
const EVENT_PREFIX = 'qcs-hint-dismissed:';

export function dismissHint(key: string) {
  const storageKey = PREFIX + key;
  try {
    localStorage.setItem(storageKey, String(Date.now()));
  } catch {
    // localStorage unavailable
  }
  window.dispatchEvent(new CustomEvent(EVENT_PREFIX + key));
}

export function useHintDismissed(hintKey: string): [dismissed: boolean, dismiss: () => void] {
  const storageKey = PREFIX + hintKey;

  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(storageKey) !== null;
    } catch {
      return false;
    }
  });

  const dismiss = useCallback(() => {
    dismissHint(hintKey);
  }, [hintKey]);

  useEffect(() => {
    const handler = () => setDismissed(true);
    window.addEventListener(EVENT_PREFIX + hintKey, handler);
    return () => window.removeEventListener(EVENT_PREFIX + hintKey, handler);
  }, [hintKey]);

  return [dismissed, dismiss];
}
